import { format } from 'date-fns';
import { IfcApplicationData } from 'models';
import { BasketDetailsModel } from 'models/Basket';
import { PaymentState } from 'store/payment';

export function prepareNonFinanceRequestData(userId: string) {
    return {
        requestType: 'CREATE_POS_CASH',
        userId: userId
    };
}

export function prepareIFCRequestData(ifcApplicationData: IfcApplicationData, basket: BasketDetailsModel, payment: PaymentState) {
    let requestData = createNestedObject(ifcApplicationData);
    cleanRequestData(requestData);

    const previousAddresses = requestData.customer.address?.previousAddresses || [];
    requestData.customer.address.previousAddresses = Object.values(previousAddresses);

    const loanAmount = payment.paymentDetails.total - payment.paymentDetails.ifcDeposit;

    if (requestData.loan?.otherDeliveryAddress) {
        requestData.loan.otherDeliveryAddress.country = 'GB';
    }

    return {
        'requestType': 'CREATE_POS',
        'userId': basket.user.uid,
        'newApplication': {
            ...requestData,
            'assisted': false,
            'retailer': {
                'id': 'SOF',
                'description': 'INTERNET',
                'branchId': '1046'
            },
            'customer':
            {
                ...requestData['customer'],
                'email': basket.user.uid
            },
            'loan': {
                ...requestData['loan'],
                'type': 'IF',
                'cashPrice': `${payment.paymentDetails.total.toFixed(2)}`,
                'deposit': `${payment.paymentDetails.ifcDeposit.toFixed(2)}`,
                'loanAmount': `${loanAmount.toFixed(2)}`,
                'instalments': payment.paymentDetails.ifcNumMonths,
                'deliveryDate': format(new Date(basket.eca!), 'yyyy-MM-dd'),
                'goodsDescription': 'furniture'
            }
        }
    };
}

function createNestedObject(objects: any) {
    const result: Record<string, any> = {};

    for (const key in objects) {
        const keys = key.split('.');
        let currentObj = result;

        for (let i = 0; i < keys.length - 1; i++) {
            if (!currentObj[keys[i]]) {
                currentObj[keys[i]] = {};
            }

            currentObj = currentObj[keys[i]];
        }

        currentObj[keys[keys.length - 1]] = objects[key];
    }

    return result;
}

function cleanRequestData(obj: any) {
    for (let propName in obj) {
        if (propName === 'isBankDetailsConfirmed' || propName === 'differentDeliveryAddress' || obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
            delete obj[propName];
        } else if (typeof obj[propName] === 'object') {
            cleanRequestData(obj[propName]);
            if (Object.keys(obj[propName]).length === 0) {
                delete obj[propName];
            }
        }
    }
}
